import React, { useState, useEffect } from 'react';
import './App.css';
import QuizForm from './components/QuizForm';
import EmailCapture from './components/EmailCapture';
import Results from './components/Results';

const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, { app: 'find_my_business', ...params });
  }
};

function App() {
  const [step, setStep] = useState('quiz'); // quiz, email, results

  useEffect(() => {
    trackEvent('page_viewed', { page: 'landing' });
  }, []);
  const [formData, setFormData] = useState(null);
  const [email, setEmail] = useState('');
  const [recommendations, setRecommendations] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleQuizSubmit = (data) => {
    setFormData(data);
    setStep('email');
  };

  const handleEmailSubmit = async (userEmail, quizData) => {
    setEmail(userEmail);
    setStep('results');
    setLoading(true);

    try {
      // Call your Firebase function
      const response = await fetch('https://us-central1-find-my-business-ba806.cloudfunctions.net/getBusinessRecommendations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: userEmail,
          answers: quizData
        })
      });

      const data = await response.json();
      
      if (data.success && data.recommendations) {
        setRecommendations(data.recommendations);
      } else {
        throw new Error('Failed to get recommendations');
      }
    } catch (error) {
      console.error('Error:', error);
      // Show fallback recommendations
      setRecommendations([
        {
          businessName: "Content Creation Business",
          description: "Help businesses create compelling content",
          difficulty: "Medium",
          incomePotential: "$3,000-$8,000/month",
          timeToFirstDollar: "2-4 weeks",
          startupCost: "$0-$500",
          whyThisMatches: "Based on your answers, this aligns with your strengths",
          firstSteps: "1. Choose your niche\n2. Create portfolio samples\n3. Reach out to 10 potential clients",
          monetizationStrategy: "Charge per project or monthly retainers",
          commonMistakes: "Don't undervalue your work - charge what you're worth"
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>
          <span style={{ color: '#00d2ff' }}>Find</span>{' '}
          <span style={{ color: 'white' }}>My Business</span>
        </h1>
        <p className="subtitle">Discover your perfect business idea based on YOUR strengths</p>
        <p style={{
          marginTop: '0.6rem',
          fontSize: '0.95rem',
          color: '#00d2ff',
          fontWeight: '600',
          letterSpacing: '0.02em'
        }}>
          12 questions &mdash; takes about 2 minutes
        </p>
      </header>

      <main className="main-content">
        {step === 'quiz' && (
          <>
            {/* 3-step process visual */}
            <div className="process-steps" style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '0',
              maxWidth: '720px',
              margin: '0 auto 2.5rem',
              borderRadius: '14px',
              overflow: 'hidden',
              border: '1px solid rgba(0, 210, 255, 0.2)',
            }}>
              {[
                { num: '1', text: 'Answer 12 questions about your goals and skills' },
                { num: '2', text: 'Get your personalized business match' },
                { num: '3', text: 'Download your results and take the next step' },
              ].map((item, i, arr) => (
                <div key={i} style={{
                  flex: 1,
                  background: '#111111',
                  padding: '1.4rem 1.1rem',
                  textAlign: 'center',
                  borderRight: i < arr.length - 1 ? '1px solid rgba(0, 210, 255, 0.15)' : 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '0.6rem',
                }}>
                  <div style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    background: 'rgba(0, 210, 255, 0.15)',
                    border: '2px solid #00d2ff',
                    color: '#00d2ff',
                    fontWeight: '800',
                    fontSize: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    {item.num}
                  </div>
                  <p style={{
                    margin: 0,
                    fontSize: '0.85rem',
                    color: '#cccccc',
                    lineHeight: '1.5',
                  }}>
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
            <QuizForm onSubmit={handleQuizSubmit} />
          </>
        )}
        {step === 'email' && <EmailCapture onSubmit={handleEmailSubmit} formData={formData} />}
        {step === 'results' && <Results recommendations={recommendations} email={email} />}
      </main>

      <footer style={{ 
        marginTop: '4rem', 
        padding: '2rem', 
        textAlign: 'center', 
        opacity: 0.7,
        fontSize: '0.9rem'
      }}>
        <p>Part of the FIND → BUILD System by Designer of Content</p>
        <p style={{ marginTop: '0.5rem' }}>
          🔍 Find My Business → 💎 Find My Customers → 🎯 Find My Lead Magnet → 🚀 Build My Leads
        </p>
      </footer>
    </div>
  );
}

export default App;
